import { namespacedConsts } from '../../jsCore/utils/object';


export const JWPLAYER_ACTION_TYPES = namespacedConsts({
  SDK_LOADED: true,
  LOAD_SDK: true,
  ANALYTICS: {
    VIDEO_PLAY: true,
    VIDEO_COMPLETE: true,
    VIDEO_PAUSE: true,
    VIDEO_PERCENTAGE_CHANGE: true,
  }
});

function createSubLabel(position, duration){
  return `current position=${position}sec; video duration=${duration}sec;`;
}

export const loadSdk = _ => ({
  type: JWPLAYER_ACTION_TYPES.LOAD_SDK,
});

export const sdkLoaded = _ => ({
  type: JWPLAYER_ACTION_TYPES.SDK_LOADED,
});

export const jwplayerAnalyticsPlayAction = (videoId, pageType, videoMainWrapperName, duration, position) => ({
  type: JWPLAYER_ACTION_TYPES.ANALYTICS.VIDEO_PLAY,
  state: {
    payload: {
      category: pageType,
      action: `jw ${videoMainWrapperName} video play`,
      label: videoId,
      sub_label: createSubLabel(position, duration),
    },
  },
});

export const jwplayerAnalyticsCompleteAction = (videoId, pageType, videoMainWrapperName, duration, position) => ({
  type: JWPLAYER_ACTION_TYPES.ANALYTICS.VIDEO_COMPLETE,
  state: {
    payload: {
      category: pageType,
      action: `jw ${videoMainWrapperName} video complete`,
      label: videoId,
      sub_label: createSubLabel(position, duration),
    },
  },
});

export const jwplayerAnalyticsPauseAction = (videoId, pageType, videoMainWrapperName, duration, position) => ({
  type: JWPLAYER_ACTION_TYPES.ANALYTICS.VIDEO_PAUSE,
  state: {
    payload: {
      category: pageType,
      action: `jw ${videoMainWrapperName} video paused`,
      label: videoId,
      sub_label: createSubLabel(position, duration),
    },
  },
});

export function jwplayerAnalyticsPercentageChangeAction(videoId, pageType, videoMainWrapperName, time, percentage){
  return {
    type: JWPLAYER_ACTION_TYPES.ANALYTICS.VIDEO_PERCENTAGE_CHANGE,
    state: {
      payload: {
        category: pageType,
        label: videoId,
        action: `jw ${videoMainWrapperName} video ${percentage}% complete`,
        sub_label: createSubLabel(time.position, time.duration),
      },
    },
  };
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/jwplayer/jwplayerActions.js